import franwell from './franwell';
import yioak from './yioak';

const brands = {
  franwell,
  yioak,
};

const brandId = process.env.VUE_APP_BRAND || 'franwell';
const base = brands[brandId] || franwell;

/**
 * 当前构建品牌（编译期由 VUE_APP_BRAND 决定）
 * 用法：this.$brand.name / this.$brand.theme.primary
 */
const brand = {
  ...base,
  logoUrl: `${process.env.VUE_APP_IMG_BASE_URL || ''}${base.logoFile}`,
};

/** 把主题写入 :root CSS 变量，页面样式用 var(--brand-*) */
export function applyBrandTheme(target = document.documentElement) {
  const { theme } = brand;
  const vars = {
    '--brand-primary': theme.primary,
    '--brand-primary-start': theme.primaryStart,
    '--brand-primary-end': theme.primaryEnd,
    '--brand-primary-disabled-start': theme.primaryDisabledStart,
    '--brand-primary-disabled-end': theme.primaryDisabledEnd,
    '--brand-page-bg': theme.pageBg,
    '--brand-body-bg': theme.bodyBg,
    '--brand-gradient':
      theme.gradient ||
      `linear-gradient(145deg, ${theme.primaryStart} 0%, ${theme.primaryEnd} 100%)`,
    '--brand-gradient-h':
      theme.gradientH ||
      theme.gradient ||
      `linear-gradient(90deg, ${theme.primaryStart} 0%, ${theme.primaryEnd} 100%)`,
    '--brand-gradient-disabled':
      theme.gradientDisabled ||
      `linear-gradient(145deg, ${theme.primaryDisabledStart} 0%, ${theme.primaryDisabledEnd} 100%)`,
  };
  Object.keys(vars).forEach((key) => {
    target.style.setProperty(key, vars[key]);
  });
  target.setAttribute('data-brand', brand.id);
  if (typeof document !== 'undefined') {
    document.title = brand.title || brand.name;
  }
}

export function getBrand() {
  return brand;
}

export default brand;
